<template>
  <div class="com-service-block">
    <div class="com-intr-title">
      <title-text title="公司服务"></title-text>
    </div>
    <div class="service-content">
      <div class="service-item">
        <div>
          <p class="service-title">服务形态</p>
          <img src="">
          <hr>
          <p class="service-msg">一站式服务营销</p>
        </div>
        <div>
          <p class="service-title">服务内涵</p>
          <img src="">
          <hr>
          <p class="service-msg">提升企业品牌影响力</p>
        </div>
        <div>
          <p class="service-title">商业价值</p>
          <img src="">
          <hr>
          <p class="service-msg">提高企业品牌知名度，微信公众号涨粉，APP引流</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleText from './TitleText'

export default {
  name: 'ComService',
  components: {TitleText}
}
</script>

<style scoped lang="stylus">
.com-service-block
  height 480px
  width 1070px
  margin 0 auto
  padding-top 100px

  .service-content
    margin-top 30px
    .service-item
      display flex
      justify-content space-between
      align-items center

      .service-title
        font-size 28px
        margin 20px
        display inline-block
      .service-msg
        margin 23px 17px

      div
        height 140px
        background-color #dcdcdc
        hr
          border 1.5px solid #bfbfbf
          margin 0
          float: left
          margin-left 17px
      div:first-child
        width 280px
        hr
          width 245px
      div:nth-child(2)
        width 321px
        hr
          width 285px
      div:nth-child(3)
        width 404px
        hr
          width 370px
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/components/ComService.vue